import DataTable from "datatables.net-dt";
import languageUK from 'datatables.net-plugins/i18n/uk.mjs';
import fetchGetRedRestApi from "../services/fetch-get-red-rest-api";

export default () => ({
    dataset: [],
    columns: [],
    dataTable: null,
    isLoading: true,

    async init() {
        try {
            const {success, message, data} = await fetchGetRedRestApi('course-assignment/assigned-by-me')

            if (success) {
                this.reportTable = new DataTable(this.$refs.dataTable, {
                    data: data.dataset,
                    pageLength: 10,
                    deferRender: true,
                    fixedHeader: true,
                    responsive: true,
                    scrollX: true,
                    autoWidth: true,
                    language: languageUK,
                    order: [[2, 'desc']],
                    fixedColumns: {
                        start: 2
                    },
                    layout: {
                        topEnd: {
                            search: {
                                boundary: true
                            }
                        }
                    },
                    columns: data.columns.map((col, index) => {
                        if (index === 0) {
                            return {
                                ...col,
                                render: function (data, type, row) {
                                    const url = row['course_link']
                                    return `<a href="${url}" target="_blank" title="${data}">${data}</a>`
                                }
                            };
                        }

                        return col
                    }),
                    createdRow: function (row, data, dataIndex) {
                        row.classList.add(data.status || 'default-status')
                        row.classList.add(data.assignment_active ? 'active' : 'inactive')
                    }
                })
            }
        } catch (error) {
            console.error(error)
        } finally {
            this.isLoading = false;
        }
    },
})